module.exports = __webpack_public_path__ + "static/kgh-demo-0fc9eacdbaa3b3ef4abf8c5544c4c7b3.png";